import React, { useState } from "react";
import axios from "axios";
import moment from "moment";
import { Button, Space, Modal, message } from "antd";
import { DownloadOutlined, DeleteFilled } from "@ant-design/icons";
import { usePermissions } from "../App/PermissionContext";
import { PERMISSIONS } from "../../constants/roles";

const UserButtons = ({ selectedRowKeys, users, filters, pagination }) => {
  const { permissions } = usePermissions();
  const [isDownloading, setIsDownloading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const downloadCSV = async () => {
    const queryString = new URLSearchParams(filters).toString();

    const hasSelection = selectedRowKeys.length > 0;
    const count = hasSelection
      ? selectedRowKeys.length
      : pagination.pagination.totalSize;

    const messageContent = (
      <p>
        Are you sure you want to download {count} user data ?<br />
      </p>
    );

    Modal.confirm({
      content: messageContent,
      title: `Download User List ?`,
      async onOk() {
        const searchParams = new URLSearchParams(queryString);
        if (hasSelection) {
          selectedRowKeys.forEach(key => searchParams.append("userIds[]", key));
        } else {
          searchParams.set("total", pagination.pagination.totalSize);
        }
        const finalQueryString = searchParams.toString();

        await axios
          .get(`/api/users/csv?${finalQueryString}`)
          .then((res) => {
            message.info(`Please check the Export progress in System -> Jobs`);
          })
          .catch((error) => {
            message.error(error.message);
          });
      },
    });
  };

  const lockUser = async () => {
    setIsLoading(true);
    selectedRowKeys.forEach(async (row) => {
      const postJson = {
        merchantId: row,
        lockedTier: true,
      };
      await axios
        .patch("api/merchant/lock/tier", postJson)
        .then(function (response) {
          message.info("Changes Updated");
        });
    });
    setIsLoading(false);
  };

  const unlockUser = async () => {
    //const data = this.state.data;
    selectedRowKeys.forEach(async (row) => {
      console.log("The row", row);
      const postJson = {
        merchantId: row,
        lockedTier: false,
      };
      await axios
        .patch("api/merchant/lock/tier", postJson)
        .then(function (response) {
          message.info("Changes Updated");
        });
    });
  };
  return (
    <div style={{ marginBottom: 16, float: "right" }}>
      <Space>
        {permissions?.includes(PERMISSIONS.EXPORT_USER_LIST) && (
          <span>
            <Button onClick={downloadCSV} loading={isDownloading}>
              CSV <DownloadOutlined></DownloadOutlined>
            </Button>
          </span>
        )}
        <span>
          {selectedRowKeys.length > 0 && (
            <Button
              onClick={() => {
                unlockUser(selectedRowKeys);
              }}
            >
              Unlock Tier
            </Button>
          )}
        </span>
        <span>
          {selectedRowKeys.length > 0 && (
            <Button
              onClick={() => {
                lockUser(selectedRowKeys);
              }}
            >
              Lock Tier
            </Button>
          )}
        </span>
        <span>
          {selectedRowKeys.length > 0 && (
            <Button>
              <DeleteFilled className="icons" />
            </Button>
          )}
        </span>
      </Space>
    </div>
  );
};

export default UserButtons;
